import { Http, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

let HOST = environment.apiHost;

@Injectable()
export class NewVersionService {


    constructor(private http: Http, private httpClient: HttpClient) { }

    sendActivity(param, data?: any): Promise<any> {
        
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            file: param.file,
            action: param.action,
            user: param.user
        }

        return this.httpClient.post(HOST + '/send_activity', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('file', param.file);
        // params.set('action', param.action);
        // params.set('user', param.user);

        // return this.http.post(HOST + '/send_activity', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }

    sendVersionData(param, data?: any): Promise<any> {

        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            version: param.version,
            projectID: param.projectID,
            // session: param.session,
        }

        return this.httpClient.post(HOST + '/create-version', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('version', param.version);
        // params.set('projectID', param.projectID);
        // params.set('session', param.session);

        // return this.http.post(HOST + '/create-version', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }

    getLastVersion(param, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            project: param.project,
            component: param.component
        };

        return this.httpClient.post(HOST + '/last-version', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('project', param.project);
        // params.set('component', param.component);

        // return this.http.post(HOST + '/last-version', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }

    getSupportProject(param, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            session: param.session
        };

        return this.httpClient.post(HOST + '/project-mapping', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('project', param.project);

        // return this.http.post(HOST + '/project-mapping', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }


}
